import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaFacebook, FaInstagram, FaEnvelope, FaGithub, FaLinkedin, FaXTwitter, FaPhone, FaDownload, FaLink } from "react-icons/fa6";
import { bannerImg } from "../../assets/index";
import { motion } from "framer-motion";
import { SiResearchgate } from "react-icons/si";

const Left = () => {
  const [text] = useTypewriter({
    words: ["Software Engineer", "Full Stack Developer", "AI/ML/Data Engineer"],
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 20,
    delaySpeed: 2000,
  });

  return (
    <motion.div
      initial={{ x: -120, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="w-full lgl:w-5/12 h-full lg:h-[750px]  bg-bodyColor rounded-2xl shadow-testShwdow z--1"
    >
      <div className="w-full aspect-[4/5] lg:h-3/5">
        <img
          src={bannerImg}
          alt="Zakawat Abbas banner"
          className="w-full h-full object-contain object-center p-4 sm:p-6 md:p-10 lg:px-14 lg:pb-6"
          loading="eager"
        />
      </div>
      <div className="w-full h-2/5 flex flex-col justify-between border-t-0 rounded-bl-xl rounded-br-xl">
        <div className="flex flex-col items-center gap-2 py-10 pt-0">
          <h1 className="text-textColor text-3xl font-semibold px-2">
            Zakawat Abbas
          </h1>
          <p className="text-base text-designColor tracking-wide">
            {text}
            <Cursor cursorBlinking="false" cursorStyle="|" />
          </p>
          <div className="flex justify-center gap-2 mt-2">
            <a
              href="https://github.com/Zakawat-Abbas"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/zakawat-abbas/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.researchgate.net/profile/Zakawat-Abbas-2"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <SiResearchgate />
            </a>
            <a
              href="https://www.facebook.com/zakawat.abbas"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/zakawatabbas/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <FaInstagram />
            </a>
            <a
              href="https://x.com/ZakawatAbbas"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <FaXTwitter />
            </a>
            <a
              href="mailto:zakawatabbas123@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-xl"
            >
              <FaEnvelope />
            </a>
            <a
              href="tel:+923423235676"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-lg"
            >
              <FaPhone />
            </a>
            <a
              href="https://zakawat-abbas.github.io/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-designColor duration-300 cursor-pointer text-lg"
            >
              <FaLink size={22} />
            </a>
          </div>
        </div>
        <div className="flex justify-center h-14 border-t-[1px] border-t-zinc-800">
          <a
            href="https://flowcv.com/resume/ev47wjl2hu"
            target="_blank"
            className="w-1/2 text-sm tracking-wide uppercase gap-2 hover:text-designColor duration-300"
            rel="noreferrer"
          >
            <button className="w-full h-full flex justify-center items-center gap-2">
              Download CV
              <FaDownload />
            </button>
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Left;
